import { H2Heading } from "../../Headers";
import { ArticleParagraph } from "../../Paragraphs";
import { InfoBox, MiniFormulaBox } from "./InfoBox";

export const StageMinSpan = ({ rowLength, clues, minSpan, slack, isImpossible, forcedOverlapSegments }) => {
    const clueText = clues.length > 0 ? clues.join(', ') : 'none';
    const gapCount = Math.max(clues.length - 1, 0);
    const formula = clues.length > 0
        ? `Minimum span = ${clues.join(' + ')} + ${gapCount} = ${minSpan}`
        : 'Minimum span = 0';
    const forcedBlocks = forcedOverlapSegments.filter((seg) => seg.overlapLength > 0);

    return (
        <div className="my-8">
            <H2Heading>Stage 1 — How much room do the blocks need?</H2Heading>

            <ArticleParagraph
                lines={[
                    `A clue of ${clueText} needs at least one gap between each block. Add up the block lengths and the gaps between them, and you get the minimum span: the shortest row that could possibly fit this clue.`
                ]}
            />

            <MiniFormulaBox
                formula={formula}
                description="Sum of the block lengths, plus one gap cell between each pair of blocks."
            />

            {isImpossible ? (
                <InfoBox title="These clues don't fit" type="warning">
                    This clue needs at least {minSpan} cells, but the row is only {rowLength} cells long.
                    Increase the row length or remove a block to continue.
                </InfoBox>
            ) : (
                <>
                    <p className="text-sm text-gray-700 mb-4 text-center sm:text-left">
                        The row has {rowLength} cells, so there's <strong>{slack}</strong> {slack === 1 ? 'cell' : 'cells'} of slack — room for the whole arrangement to shift left or right. Any block longer than that slack has cells that must be filled no matter where it ends up landing.
                    </p>

                    {forcedBlocks.length > 0 ? (
                        <ul className="text-sm text-gray-700 list-disc list-inside space-y-1 mb-4">
                            {forcedBlocks.map((seg) => (
                                <li key={seg.blockIndex}>
                                    Block of {seg.length}: its middle {seg.overlapLength} {seg.overlapLength === 1 ? 'cell is' : 'cells are'} guaranteed filled, wherever it lands.
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-gray-500 italic mb-4">
                            With {slack} {slack === 1 ? 'cell' : 'cells'} of slack, no block is long enough to force an overlap with itself yet — every block can slide clear of its own leftmost position.
                        </p>
                    )}
                </>
            )}
        </div>
    );
};
